module.exports = [
  // type
  require('./Unit'),

  // construction function
  require('./function/unit'),

  // create new units
  require('./function/createUnit'),

  // split units
  require('./function/splitUnit'),

  // physical constants
  require('./physicalConstants')
];



//////////////////
// WEBPACK FOOTER
// ./node_modules/mathjs/lib/type/unit/index.js
// module id = 1187
// module chunks = 0